<template>
  <div class="header">
    <div class="logo" :style="{backgroundImage: 'url(' + logoUrl + ')'}" @click="$router.push('/home')"></div>
    <div class="menu">
      <!-- <div v-for="(item,index) in route" :key="item.title" class="menu-box"> -->
      <div v-for="item in route" :key="item.title" class="menu-box">
        <router-link :to="item.path" class="menu-link">
          <i class="iconfont menu-icon" :class="item.icon"></i>
          <span class="menu-title">{{item.title}}</span>
        </router-link>
        <!-- 菜单间的| -->
        <!-- <div class="line" v-if="!(index == route.length-1)" ></div> -->
      </div>
    </div>
    <!-- 新旧版切换按钮 -->
    <!-- v-if="role.id==0" -->
    <div class="version-oldbox">
      <button @click="changeMode" v-if="isNewEdition" class="version-btn">
        <i class="iconfont icon-fanhuijiuban"></i>
        {{$t('version.to_old')}}
      </button>
      <button @click="changeMode" v-else class="version-btn">
        <i class="iconfont icon-fanhuijiuban"></i>
        {{$t('version.to_new')}}
      </button>
    </div>
    <div class="tool">
      <div v-if="role.id==0" class="add-boxs" @click="dialogDataloggerVisible=true">
        <i class="iconfont icon-tianjia"></i>
        <span>{{$t('datalogger.add')}}</span>
      </div>
      <!-- <div v-if="role.id==0" class="toggle" @click="dialogDataloggerVisible=true">+</div> -->
      <el-dropdown trigger="click" @command="changeLang" @visible-change="changeLangValue">
        <span class="dropdown-trigger">
          <span class="language">
            <img :src="imgurl" style="width:32px;height:24px;" />
            {{langActive}}
          </span>
          <i v-if="this.changeValue" class="el-icon-arrow-up"></i>
          <i v-else class="el-icon-arrow-down"></i>
          <!-- <span class="caret"></span> -->
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown">
          <el-dropdown-item
            v-for="item in langList"
            style="align-items: center;display: flex;"
            :command="item.value"
            :key="item.name"
            :class="{selected: currentLang==item.value}"
          >
            <img :src="item.imgurl" style="width:24px;height:24px;float: left;margin-right:5px" />
            {{item.name}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" @command="handleUsrCommand" @visible-change="changeUsrValue">
        <span class="dropdown-trigger">
          <img v-if="avatar" class="avatar" :src="avatar" alt="avatar" />
          <img v-else class="avatar" src="@/assets/img/avatar.png" alt="avatar" />
          <!-- <span class="username">{{username || 'Welcome'}}</span> -->
          <span class="username">{{usernameLenght}}</span>
          <i v-if="this.changeUsr" class="el-icon-arrow-up"></i>
          <i v-else class="el-icon-arrow-down"></i>
          <!-- <span class="caret"></span> -->
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown">
          <div class="info-container">
            <img v-if="avatar" class="avatar" :src="avatar" alt="avatar" />
            <img v-else class="avatar" src="@/assets/img/avatar.png" alt="avatar" />
            <div class="info">
              <span class="username">{{username}}</span>
              <span class="role">{{role.name}}</span>
            </div>
          </div>
          <el-dropdown-item command="goInfo"><i class="iconfont icon-accountSet"></i>{{$t('header.personal_infor')}}</el-dropdown-item>
          <el-dropdown-item command="goPwd"><i class="iconfont icon-mima"></i>{{$t('header.change_password')}}</el-dropdown-item>
          <el-dropdown-item class="logout" command="logout"><i class="iconfont icon-tuichu"></i>{{$t('header.log_out')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--创建数采器-->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      @submitSuc="handleCreateSuc"
      v-if="dialogDataloggerVisible"
    ></datalogger-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import filter from "@/assets/js/filter";
import cookie from "@/assets/js/cookie.js";
import dataloggerDialog from "@/components/dialog/datalogger";
// import beebeejump from "@/assets/img/beebeejump/logo-pic.png";
// import tgpro from "@/assets/img/tgpro/logo-pic.png";
import dessmonitorLogo from "@/assets/img/default/logo-pic.png";
import axios from 'axios';
import Store from '@/store'
export default {
  props: {
    roleType: {
      default: "admin"
    }
  },
  components: {
    dataloggerDialog
  },
  data() {
    return {
      serverNodeList: [],
      serverNodeValue: false,
      changeValue: false,
      changeUsr: false,
      imgurl: "",
      isNewEdition:false,
      skinList: Object.keys(this.$filter.skin),
      showSkinList: false, // 显示皮肤列表
      dialogDataloggerVisible: false, // 是否显示创建数采器弹窗
      logoUrl:null
    };
  },
  computed: {
    ...mapState({
      route: state => {
        let result = [];
        state.user.route.forEach(route => {
          if (route.path && route.meta) {
            result.push({
              path: route.path,
              ...route.meta
            });
          }
        });
        return result;
      },
      username: state => state.user.username,
      avatar: state => state.user.avatar,
      role: state => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group
        };
      }
    }),
    ...mapGetters(["getSkin"]),
    langList() {
      var hostname = window.location.hostname;
      var langList = []
      //比比赞定制只有英文
      if(hostname=="beebeejump.dessmonitor.com"){
        langList.push(this.$lang.langList[0])
        return langList;
      }else{
        return this.$lang.langList;
      }
    },
    currentLang() {
      return this.$lang.currentLang;
    },
    langActive() {
      var lang;
      this.$lang.langList.forEach(element => {
        if (element.value == this.$lang.currentLang) {
          lang = element.name;
        }
      });
      return lang;
    },
    usernameLenght() {
      if (this.username) {
        if (this.$lang.currentLang == "zh_CN") {
          if (this.username.length > 6) {
            return this.username.substring(0, 6) + "...";
          } else {
            return this.username;
          }
        } else {
          if (this.username.length > 12) {
            return this.username.substring(0, 12) + "...";
          } else {
            return this.username;
          }
        }
      } else {
        return "Welcome";
      }
    }
  },
  created() {
    this.determineHost();
    // this.getServerNode();
    this.$lang.langList.forEach(item => {
      if (item.value == this.$lang.currentLang) {
        this.imgurl = item.imgurl;
      }
    });
  },
  methods: {
    //判断域名修改logo
    determineHost() {
      this.logoUrl = dessmonitorLogo
      let DomainNameStr = window.document.location.hostname;
      var DomainNameIMG = new Image()
      var _this = this
      DomainNameIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.ico"
      DomainNameIMG.onload = function () {
        _this.logoUrl = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.ico"
      }

      // axios.get(document.location.protocol + '//img.shinemonitor.com/file/', {
      //     params: {
      //       action: 'queryAllCustInfosByDomainName',
      //       domainName: window.document.location.hostname,
      //       sign: 'dessmonitor',
      //       salt: new Date().getTime(),
      //       source: 1,
      //     }
      //   })
      //     .then(resp => {
      //       this.logoUrl = resp.dat.logoStr;
      //     }).catch(err => {       //
      //       console.log(err)
      //     });
      // var hostname = window.location.hostname;
      // switch (hostname) {
      //   case "beebeejump.dessmonitor.com":
      //     this.logoUrl = beebeejump;
      //     break;
      //   case "tgpropower.dessmonitor.com":
      //     this.logoUrl = tgpro;
      //     break;
      //   default:
      //     this.logoUrl = dessmonitor;
      //     break;
      // }
    },
    // getServerNode(){
    //   let param = {
    //     source: 1,
    //     _app_client_: "web",
    //     _app_id_: window.location.hostname,
    //     _app_version_: "1.0.6.3",
    //     i18n: this.$lang.currentLang
    //   }
    //   this.serverNodeList = []
    //   this.$request.get("queryDomainList",param).then(res => {
    //     if (res.err == 0) {
    //       if(res.dat.length !=0){
    //         res.dat.map((element =>{
    //           this.serverNodeList.push({
    //             name:element.name,
    //             url:element.url,
    //           })
    //         }))
    //       }else{
    //        this.serverNodeList =[{
    //         name:this.$t("version.default_node"),
    //         url:'',
    //       }]}
    //     }else{
    //       this.serverNodeList =[{
    //       name:this.$t("version.default_node"),
    //       url:'',
    //     }]}
    //   }).catch(() => {
    //     this.serverNodeList =[{
    //       name:this.$t("version.default_node"),
    //       url:'',
    //     }]});
    // },
    // 用户信息下拉框点击事件
    handleUsrCommand(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "goInfo":
          this.$router.push({
            name: this.role.group + "PersonalBasic"
          });
          break;
        case "goPwd":
          this.$router.push({
            name: this.role.group + "PersonalBasic",
            query: { tab: "pwd" }
          });
          break;
        default:
          break;
      }
    },
    // 创建数采器成功回调
    handleCreateSuc() {
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      this.$message.success(this.$t("datalogger.addSuc"));
    },
    // 登出
    logout() {
      this.$store.commit("logout");
      this.$router.push("/entry");
    },
    // 切换语言
    changeLang(currentLang) {
      this.$lang.currentLang = currentLang;
    },
    changeLangValue(changeValue) {
      this.changeValue = changeValue;
    },
    changeUsrValue(changeUsr) {
      this.changeUsr = changeUsr;
    },
    // 切换皮肤
    changeSkin(currentSkin) {
      this.$store.commit("saveSkin", currentSkin);
    },
    //切换版本
    changeMode(){
      this.isNewEdition =!this.isNewEdition
      cookie.setCookie("isNewEdition", this.isNewEdition);
      this.$store.commit("saveEditionType", {isNewEdition:this.isNewEdition});
      this.$store.commit("saveRoute", '');
      
      if(Store.state.user.role ==1 || Store.state.user.role ==2 || Store.state.user.role ==3){
        // this.$router.push("/adminNew/home");
        let val = sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false;
        if(Store.state.user.role==2&&Store.state.user.isNewEdition&&val){
            var arr = sessionStorage.getItem("moduleArr")?JSON.parse(sessionStorage.getItem("moduleArr")):[]
            if(arr.includes('overview')){
              this.$router.push("/adminNew/home");
            }else if(arr.includes('device_manag')){
              this.$router.push("/adminNew/device")
            }else if(arr.includes('account_manag')){
              this.$router.push("/adminNew/account")
            }else if(arr.includes('alarm_manag')){
              this.$router.push("/adminNew/alarm")
            }else if(arr.includes('system_settings')){
              this.$router.push("/adminNew/setting")
            }else{
              this.$router.push("/adminNew/home");
            }
          }else{
            this.$router.push("/adminNew/home");
          }
      }
      if(Store.state.user.role ==0 || Store.state.user.role ==5) {
        this.$router.push("/generalNew/home");
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");
.header {
  display: flex;
  align-items: center;
  padding-right: 24px;
  box-shadow: 0px 10px 124px rgba(0, 0, 0, 0.2);
  // border-bottom: 1px solid @borderColor;
  // box-shadow: 0 2px 2px @shadowColor;
  // background: #fff;
  background: @themeBg;
  z-index: 4;
  height: 64px;
  .logo {
    width: 256px;
    // height: 48px;
    height: 100%;
    text-align: center;
    background: url("../assets/img/logo-pic.png") no-repeat center / 210px;
    cursor: pointer;
  }
  .menu {
    flex: 1;
    height: 48px;
    margin-left: 14px;
    // padding: 5px 0 0 25px;
    .menu-box {
      display: inline-block;
      // .line{
      //   display: inline-block;
      //   width: 2px;
      //   height: 30px;
      //   margin-bottom: -10px;
      //   background-color: rgba(255, 255, 255, 0.5)
      // }
      .menu-link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
        // line-height: 48px;
        margin: auto 6px;
        // display: inline-block;
        opacity: 0.85;
        // min-width: 132px;
        padding: 0 16px;
        // text-align: center;
        border-radius: 10px;
        // border-right:1px solid #f00;
        .sc(14px, #fff);
        cursor: pointer;
        &:hover {
          opacity: 0.85;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.2),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.2)
          );
        }
        &.active {
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.2),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.2)
          );
          // color: #fff;
          font-weight: bold;
        }
        .menu-icon {
          font-size: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .tool {
    display: flex;
    align-items: center;
    height: 64px;
    line-height: 64px;
    .add-boxs {
      display: flex;
      padding: 0 16px;
      // margin:auto 10px;
      // display: inline-block;
      // min-width: 132px;
      height: 48px;
      line-height: 48px;
      // padding: 11px;
      // text-align: center;
      border-radius: 10px;
      background: #fff;
      .sc(16px, #000);
      // color: #000;
      // background: @themeColor;
      // &:hover,
      // &:focus {
      //   background: @hoverColor;
      // }
      // &:active {
      //   background: @activeColor;
      // }
      // .sc(14px, #fff);
      cursor: pointer;
      .iconfont {
        font-size: 20px;
        margin-right: 8px;
      }
    }
    .toggle {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: 30px;
      line-height: 30px;
      text-align: center;
      color: @themeColor;
      border-radius: 50%;
      background: #fff;
      cursor: pointer;
    }
    > :not(:first-child) {
      margin-left: 30px;
    }
    .iconfont {
      font-size: 28px;
      cursor: pointer;
    }
    .dropdown-trigger {
      display: flex;
      align-items: center;
      color: #ffffff;
      // font-size: 16px;
      padding: 0 10px;
      &:hover,
      &:focus {
        background: @activeColor;
        padding: 0 10px;
      }
      &:active {
        background: @activeColor;
        padding: 0 10px;
      }
      cursor: pointer;
      .avatar {
        border-radius: 50%;
        width: 30px;
        height: 30px;
      }
      .username {
        margin: 0 10px;
        .sc(14px, #ffffff);
      }
      .language {
        margin-right: 8px;
        font-size: 14px;
        align-items: center;
        display: flex;
      }
      // .caret {
      //   width: 0;
      //   height: 0;
      //   border-top: 7px solid #ccc;
      //   border-left: 7px solid transparent;
      //   border-right: 7px solid transparent;
      // }
    }
  }
}
.dropdown {
  overflow: visible;
  .info-container {
    // width: 200px;
    padding: 12px 30px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      white-space: nowrap;
      .username {
        .sc(14px, #333);
      }
      .role {
        margin-top: 5px;
        .sc(14px, #999);
      }
    }
  }
  .language-item {
    padding: 3px 15px;
    &.selected {
      color: @themeColor;
    }
  }
  .skin {
    position: relative;
    padding: 0;
    .arrow {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
    .list {
      position: absolute;
      background: #fff;
      top: -1px;
      right: 100%;
      border: 1px solid @borderColor;
      border-radius: 2px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .item {
        padding: 0 20px;
        line-height: 40px;
        white-space: nowrap;
        border-bottom: 1px solid @borderColor;
        &:hover {
          background: #f2f2f2;
        }
        &.selected {
          color: @themeColor;
        }
      }
    }
  }
  // .logout {
  //   height: 41px;
  //   color: #FB807D;
  //   &:hover {
  //     color: lighten(#FB807D, 5%);
  //   }
  // }
}
</style>
<style lang="less">
// 新旧版切换
.version-oldbox {
  .version-btn {
    border: 1px solid rgb(255, 255, 255);
    border-radius: 5px;
    background: transparent;
    color: rgb(255, 255, 255);
    padding: 8px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 30px;
    cursor: pointer;
    i {
      font-size: 24px;
      margin-right: 5px;
    }
  }
}
</style>
